export const PII_FIELDS = ["name", "email"] as const;
